import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Input, Component, ViewChild } from '@angular/core';

class ImageMapperComponent {
    constructor() {
        this.alt = '';
        this.title = '';
        this.errorImage = '';
        this.imgClass = '';
        this.loading = 'lazy';
        this.fetchPriority = 'auto';
        this.imageType = '';
    }
    ngOnInit() {
        const fbImageType = this.fallbackImage && this.fallbackImage.split('.');
        this.imageType =
            (fbImageType && fbImageType[fbImageType.length - 1]) || 'png';
    }
    onError(event) {
        if (!this.errorImage) {
            return;
        }
        const target = event.target;
        if (!target.src.includes(this.errorImage)) {
            target.src = this.errorImage;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: ImageMapperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.6", type: ImageMapperComponent, isStandalone: true, selector: "magneto-image-mapper", inputs: { webpImage: "webpImage", fallbackImage: "fallbackImage", alt: "alt", title: "title", errorImage: "errorImage", imgClass: "imgClass", loading: "loading", fetchPriority: "fetchPriority" }, ngImport: i0, template: "<ng-container\n  *ngIf=\"webpImage && fallbackImage; then pictureEl; else imgEl\"\n></ng-container>\n\n<ng-template #pictureEl>\n  <picture *ngIf=\"webpImage && fallbackImage\">\n    <source type=\"image/webp\" [srcset]=\"webpImage\" />\n    <source\n      [type]=\"imageType === 'png' ? 'image/png' : 'image/jpeg'\"\n      [srcset]=\"fallbackImage\"\n    />\n    <img\n      [attr.fetchpriority]=\"fetchPriority\"\n      [src]=\"fallbackImage\"\n      [alt]=\"alt\"\n      [title]=\"title\"\n      [class]=\"imgClass\"\n      [attr.loading]=\"loading\"\n      (error)=\"onError($event)\"\n    />\n  </picture>\n</ng-template>\n<ng-template #imgEl>\n  <ng-container\n    *ngIf=\"fallbackImage; then fallbackEl; else noImgEl\"\n  ></ng-container>\n  <ng-template #fallbackEl>\n    <img\n      [attr.fetchpriority]=\"fetchPriority\"\n      class=\"fallback-img\"\n      (error)=\"onError($event)\"\n      [src]=\"fallbackImage\"\n      [alt]=\"alt\"\n      [title]=\"title\"\n      [class]=\"imgClass\"\n      [attr.loading]=\"loading\"\n    />\n  </ng-template>\n  <ng-template #noImgEl></ng-template>\n</ng-template>\n", styles: ["img,picture{max-width:100%;max-height:100%;height:inherit;width:inherit;border-radius:inherit}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: ImageMapperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'magneto-image-mapper', imports: [CommonModule], template: "<ng-container\n  *ngIf=\"webpImage && fallbackImage; then pictureEl; else imgEl\"\n></ng-container>\n\n<ng-template #pictureEl>\n  <picture *ngIf=\"webpImage && fallbackImage\">\n    <source type=\"image/webp\" [srcset]=\"webpImage\" />\n    <source\n      [type]=\"imageType === 'png' ? 'image/png' : 'image/jpeg'\"\n      [srcset]=\"fallbackImage\"\n    />\n    <img\n      [attr.fetchpriority]=\"fetchPriority\"\n      [src]=\"fallbackImage\"\n      [alt]=\"alt\"\n      [title]=\"title\"\n      [class]=\"imgClass\"\n      [attr.loading]=\"loading\"\n      (error)=\"onError($event)\"\n    />\n  </picture>\n</ng-template>\n<ng-template #imgEl>\n  <ng-container\n    *ngIf=\"fallbackImage; then fallbackEl; else noImgEl\"\n  ></ng-container>\n  <ng-template #fallbackEl>\n    <img\n      [attr.fetchpriority]=\"fetchPriority\"\n      class=\"fallback-img\"\n      (error)=\"onError($event)\"\n      [src]=\"fallbackImage\"\n      [alt]=\"alt\"\n      [title]=\"title\"\n      [class]=\"imgClass\"\n      [attr.loading]=\"loading\"\n    />\n  </ng-template>\n  <ng-template #noImgEl></ng-template>\n</ng-template>\n", styles: ["img,picture{max-width:100%;max-height:100%;height:inherit;width:inherit;border-radius:inherit}\n"] }]
        }], propDecorators: { webpImage: [{
                type: Input
            }], fallbackImage: [{
                type: Input
            }], alt: [{
                type: Input
            }], title: [{
                type: Input
            }], errorImage: [{
                type: Input
            }], imgClass: [{
                type: Input
            }], loading: [{
                type: Input
            }], fetchPriority: [{
                type: Input
            }] } });

class ImageMapperUtility {
    static onImgIntersection(elementRef) {
        const pictureEl = elementRef.nativeElement.querySelector('picture');
        const _imgElem = pictureEl?.querySelector('img');
        if (_imgElem && _imgElem.src !== _imgElem.baseURI) {
            this.displayPictureElement(pictureEl);
        }
    }
    static displayPictureElement(pictureEl) {
        pictureEl.classList.remove('d-none');
    }
}

class ImageMapperV2Component {
    constructor() {
        this.alt = '';
        this.title = '';
        this.errorImage = '';
        this.imgClass = '';
        this.defaultImgClass = '';
        this.loading = 'lazy';
        this.fetchPriority = 'auto';
    }
    onError(event) {
        if (!this.errorImage) {
            this.pictureEl.nativeElement.style.setProperty('z-index', '-1');
            return;
        }
        const _target = this._getHTMLImageElementFromEvent(event);
        if (!_target.src.includes(this.errorImage)) {
            _target.src = this.errorImage;
        }
        else {
            if (!this.defaultBase64Img) {
                this.showPictureElement();
            }
        }
    }
    onImgLoad(event) {
        const _target = this._getHTMLImageElementFromEvent(event);
        if (this._hasImageLoaded(_target)) {
            if (this.defaultImgEl) {
                this._resetDefaultBase64Img();
            }
            this.showPictureElement();
        }
    }
    showPictureElement() {
        ImageMapperUtility.displayPictureElement(this.pictureEl.nativeElement);
    }
    _resetDefaultBase64Img() {
        this.defaultBase64Img = '';
    }
    _getHTMLImageElementFromEvent(event) {
        return event.target;
    }
    _hasImageLoaded(img) {
        return img.complete;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: ImageMapperV2Component, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.1.6", type: ImageMapperV2Component, isStandalone: true, selector: "magneto-image-mapper-v2", inputs: { webpImage: "webpImage", fallbackImage: "fallbackImage", defaultBase64Img: "defaultBase64Img", alt: "alt", title: "title", errorImage: "errorImage", imgClass: "imgClass", defaultImgClass: "defaultImgClass", loading: "loading", fetchPriority: "fetchPriority" }, viewQueries: [{ propertyName: "defaultImgEl", first: true, predicate: ["defaultImgEl"], descendants: true }, { propertyName: "pictureEl", first: true, predicate: ["pictureEl"], descendants: true }], ngImport: i0, template: "<div class=\"img-wrapper\">\n  <img\n    *ngIf=\"defaultBase64Img\"\n    class=\"default-img\"\n    [src]=\"defaultBase64Img\"\n    [alt]=\"alt\"\n    [title]=\"title\"\n    [class]=\"defaultImgClass\"\n    #defaultImgEl\n  />\n\n  <picture\n    class=\"picture-elem\"\n    #pictureEl\n    [ngClass]=\"{ hidden: !!defaultBase64Img }\"\n  >\n    <source type=\"image/webp\" [srcset]=\"webpImage\" />\n    <source type=\"image/png\" [srcset]=\"fallbackImage\" />\n    <source type=\"image/jpeg\" [srcset]=\"fallbackImage\" />\n    <img\n      class=\"fallback-img\"\n      [src]=\"fallbackImage\"\n      [alt]=\"alt\"\n      [title]=\"title\"\n      [class]=\"imgClass\"\n      [attr.fetchpriority]=\"fetchPriority\"\n      [attr.loading]=\"loading\"\n      (error)=\"onError($event)\"\n      (load)=\"onImgLoad($event)\"\n    />\n  </picture>\n</div>\n", styles: ["img,picture{max-width:100%;max-height:100%;height:inherit;width:inherit;border-radius:inherit}.d-none{display:none}.img-wrapper{display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr;overflow:hidden;height:100%;width:inherit}.default-img,.picture-elem{grid-column-start:1;grid-column-end:3;grid-row-start:1}.picture-elem .fallback-img{height:auto;width:auto}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: ImageMapperV2Component, decorators: [{
            type: Component,
            args: [{ selector: 'magneto-image-mapper-v2', imports: [CommonModule], template: "<div class=\"img-wrapper\">\n  <img\n    *ngIf=\"defaultBase64Img\"\n    class=\"default-img\"\n    [src]=\"defaultBase64Img\"\n    [alt]=\"alt\"\n    [title]=\"title\"\n    [class]=\"defaultImgClass\"\n    #defaultImgEl\n  />\n\n  <picture\n    class=\"picture-elem\"\n    #pictureEl\n    [ngClass]=\"{ hidden: !!defaultBase64Img }\"\n  >\n    <source type=\"image/webp\" [srcset]=\"webpImage\" />\n    <source type=\"image/png\" [srcset]=\"fallbackImage\" />\n    <source type=\"image/jpeg\" [srcset]=\"fallbackImage\" />\n    <img\n      class=\"fallback-img\"\n      [src]=\"fallbackImage\"\n      [alt]=\"alt\"\n      [title]=\"title\"\n      [class]=\"imgClass\"\n      [attr.fetchpriority]=\"fetchPriority\"\n      [attr.loading]=\"loading\"\n      (error)=\"onError($event)\"\n      (load)=\"onImgLoad($event)\"\n    />\n  </picture>\n</div>\n", styles: ["img,picture{max-width:100%;max-height:100%;height:inherit;width:inherit;border-radius:inherit}.d-none{display:none}.img-wrapper{display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr;overflow:hidden;height:100%;width:inherit}.default-img,.picture-elem{grid-column-start:1;grid-column-end:3;grid-row-start:1}.picture-elem .fallback-img{height:auto;width:auto}\n"] }]
        }], propDecorators: { webpImage: [{
                type: Input
            }], fallbackImage: [{
                type: Input
            }], defaultBase64Img: [{
                type: Input
            }], alt: [{
                type: Input
            }], title: [{
                type: Input
            }], errorImage: [{
                type: Input
            }], imgClass: [{
                type: Input
            }], defaultImgClass: [{
                type: Input
            }], loading: [{
                type: Input
            }], fetchPriority: [{
                type: Input
            }], defaultImgEl: [{
                type: ViewChild,
                args: ['defaultImgEl']
            }], pictureEl: [{
                type: ViewChild,
                args: ['pictureEl']
            }] } });

/*
 * Public API Surface of image-mapper
 */
/** Components */

/**
 * Generated bundle index. Do not edit.
 */

export { ImageMapperComponent, ImageMapperUtility, ImageMapperV2Component };
